// extracted by mini-css-extract-plugin
export default {"imgContainer":"imgContainer___bn7oM","img":"img___IijQD"};